import { useGraphQLMutation } from '@betterment/graphql';
import { useAutoNavigate } from '@betterment/js-runtime';

import { EditUserLevelSettingsDocument } from '../graphql/mutation.editUserLevelSettings.generated';

export const useEditUserLevelSettings = (returnToPath?: string) => {
  const autoNavigate = useAutoNavigate();
  const [updateSecuritiesLendingEnrollment, { error, loading }] = useGraphQLMutation(EditUserLevelSettingsDocument);

  const handleUpdate = async (isEnrolled: boolean) => {
    const result = await updateSecuritiesLendingEnrollment({
      variables: {
        input: {
          isEnrolled,
        },
      },
    });

    if (result.data?.updateSecuritiesLendingEnrollment.result?.securityLending?.status) {
      if (returnToPath) {
        return autoNavigate(returnToPath);
      }

      return result.data.updateSecuritiesLendingEnrollment.result.securityLending.status;
    }

    return null;
  };

  return { handleUpdate, error, loading };
};
